module.exports = __webpack_public_path__ + "img/gifts_1.740eee4d.jpeg";